var Add5StepLinkRedirector = xClass("Add5StepLinkRedirector", BaseRedirector)
Add5StepLinkRedirector.prototype.getName = function () {
    var self = this
    return "add5StepLink"
}
Add5StepLinkRedirector.prototype.hasHighPriorityAction = function () {
    return false
}
Add5StepLinkRedirector.prototype.redirect = function () {
    var self = this
    var param = self.param

    //if (META.platform == XcloverPlatform.wechatgame) 
    {
        if (param.inviteCode && param.add5ShareId) {
            let http = ClickShareIdHttp.new(false)
            http.addEventListener(Events.kComplete, () => {
                if (param.isQuick && param.isQuick == "1"){
                    Toast.make("成功帮好友获得7步");
                }else{
                    Toast.make("成功帮好友获得5步");
                }
            })
            http.addEventListener(Events.kError, (evt = {}) => {
                Toast.make(quickGetErrorText(evt.data, "帮助链接已经失效！"))
            })
            http.load(param.inviteCode, param.add5ShareId)
        }
    }
    return true
}
module.exports = Add5StepLinkRedirector
